<template>
  <div
    ref="chartContainer"
    class="chart-container"
    style="width: 100%; height: 100%"
  ></div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
var seriesData = [
  {
    name: '强筋',
    value: 3321,
    rate: 40
  },
  {
    name: '中筋',
    value: 4544,
    rate: 50
  },
  {
    name: '弱筋',
    value: 7899,
    rate: 60
  }
]
var optionRich = {
  a: {
    width: 60,
    fontSize: 18,
    fontWeight: 400,
    color: '#FFF',
    lineHeight: 20,
    padding: [0, 50, 0, 0]
  },
}
var optionColorArr = {
  '强筋': '#00C1FF',
  '中筋': '#FFCC1A',
  '弱筋': '#00FF84',
}
seriesData.forEach((ele, i) => {
  optionRich[i] = {
    width: 20,
    fontSize: 18,
    fontWeight: 400,
    lineHeight: 30,
    color: optionColorArr[ele.name],
    align: 'center',
    padding: [0, 0, 0, 10]
  }
});

// 创建ECharts配置对象
const option = {
  // backgroundColor: '#002653',
  color: seriesData.map((item) => optionColorArr[item.name]),
  title: {
    text: "单位(万亩)",
    top: "12%",
    left:"55%",
    textStyle: {
      color:"#FFF",
      fontSize: "20",


    },

  },

  tooltip: {
    trigger: 'item',
    show: true,
    formatter: (params) => {
      const { data, name, value } = params;
      return `
               <div style="color: ${params.color}; font-size: 18px;">${name}&nbsp;&nbsp;&nbsp;<span style="font-size: 20px; color: #000; float: right;">${value}</span></div>
               <div style="color: ${params.color}; font-size: 17px;">占比&nbsp;<span style="font-size: 20px; color: #000; float: right;">${data.rate}%</span></div>
            `;
    },
  },
  grid: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    containLabel: true
  },
  legend: {
    type: 'scroll',
    orient: 'vertical',
    left: '45%',
    align: 'left',
    top: 'middle',
    icon: 'circle',
    itemHeight: 15,
    itemWidth: 15,
    itemGap: 20,
    height: 300,
    formatter: function (name) {
      let index = 0
      let value = 0;
      let rate = 0;
      seriesData.forEach((item, i) => {
        if (item.name == name) {
          value = item.value ? item.value : 0;
          rate = item.rate ? item.rate : 0;
          index = i;
        }
      })
      return `{a|${name}}{${index}|${rate + '%'}}{${index}|${'|'}}{${index}|${value}}`
    },
    textStyle: {
      rich: optionRich
    }
  },
  series: [
    {
      type: 'pie',
      center: ['25%', '50%'],
      radius: ['35%', '50%'],
      clockwise: true, //饼图的扇区是否是顺时针排布
      avoidLabelOverlap: false,
      label: {
        normal: {
          show: false,
        }
      },
      data: seriesData,
    }
  ]
};

// 创建ECharts实例的ref
const chartContainer = ref(null);

// 初始化ECharts实例
onMounted(() => {
  if (chartContainer.value) {
    const chartInstance = echarts.init(chartContainer.value);
    chartInstance.setOption(option);


    // 监听窗口尺寸变化
    window.addEventListener("resize", () => {
      chartInstance.resize();
    });
  }
});
</script>

<style scoped>
.chart-container {
  height: 400px; /* 或者自定义高度 */
  width: 100%;
}
</style>
